export default class ConversationReflectionMessage {
    /**
     * @constructor
     * @param {string} sender 
     * @param {string} content 
     */
    constructor(sender, content) {
        this._sender = sender;
        this._content = content;
    }

    get sender() {
        return this._sender;
    }

    get content() {
        return this._content;
    }

    toObject() {
        return {
            sender: this._sender,
            content: this._content,
        };
    }

    static fromObject(obj) {
        return new ConversationReflectionMessage(obj.sender, obj.content);
    }
}

export const ReflectionMessageSender = {
    PLAYER: 'player',
    COACH: 'coach',
};